<div id="billboardcomponent" [ngStyle]="styleData">
  <div class="headerbillboard">
    {{ title }}
  </div>
  <div class="bodybillboard">
    <ng-content></ng-content>
  </div>
</div>
